import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Tab from './TabBtn';
import ProcessBtn  from './ProcessBtn';//eslint-disable-line import/no-named-as-default
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import _ from 'lodash';
import * as navigationHelper from '../../../helpers/navigationHelper';

class TabbedScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",

                }
            },
            activeScreen: {},
            focusedTab: this.props.screen.sub_screens[0],
            renderedScreen: {},
            enabledScreens: [],
            completeScreens: [],
            producerNotes: appHelper.getScreenNotes(undefined, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.sub_screens.length > 0 ,//&& appHelper.canSeeContent(this.props.screen),
            tabCallbacks: {},
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
            continue_label: appHelper.getLocaleString("continue_label"),
            setNextButton: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status === objectConstants.STATUS_COMPLETE,

        };
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.setEnabledTabs = this.setEnabledTabs.bind(this);
        this.setTabActive = this.setTabActive.bind(this);
        this.setRenderedScreen = this.setRenderedScreen.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.setTabLayoutStyle = this.setTabLayoutStyle.bind(this);
        this.getPrevTab = this.getPrevTab.bind(this);
        this.getNextTab = this.getNextTab.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setTabCallbacks = this.setTabCallbacks.bind(this);
        this.getTabComponent =  this.getTabComponent.bind(this);
        this.includeIcons =  this.includeIcons.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
    }

    componentDidMount() {
        this.props.actions.setNextButtonState(false);
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.props.actions.setScreenTitle(this.state.locale.title);
        this.getAssets();
        this.setCallbacks();
        this.setTabCallbacks();
        if (this.state.screenIsReady) {
            this.setEnabledTabs();
            this.setTabActive(this.state.screen.sub_screens[0]);
        } else {
            this.setScreenNotReadyYet();
        }
    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens,
                setNextButton: true,
            });
        }else if(this.state.isOpenNavigation){
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label")
            });

            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }

        if(this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview){
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(undefined, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }

        this.setState({userData: Object.assign({}, nextProps.userData)});
    }

    componentDidUpdate() {
        if (typeof this.state.renderedScreen.data === "undefined" && typeof this.state.activeScreen.screen_id !== "undefined") {
            this.setRenderedScreen();

        }
        if(this.state.setNextButton){
            this.handleNextButton();
        }
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet() {
        this.setState({status: objectConstants.STATUS_COMPLETE, setNextButton: true});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens,
                setNextButton: true,
            });
        }else if(this.state.isOpenNavigation){
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
        /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
         let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
        // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
         this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
         */
    }

    getAssets() {
        let background = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        //console.log(`getBiteId`);
        return this.props.biteCallbacks.getBiteId();
    }

    setEnabledTabs() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            //if (this.state.screen.progression === objectConstants.OBJECT_PROGRESSION_LINEAR) {

            //} else {
            //    this.setState({enabledObjects: Object.assign([], this.state.screen.objects)});
            // }
            if(this.state.isOpenNavigation) {
                this.setState({
                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
                });
            }else{
                this.setState({enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0])});
            }
        } else {
            //  console.log("hello");
            this.setState(
                {
                    enabledObjects: Object.assign([], this.state.screen.objects),
                    completeObjects: Object.assign([], this.state.screen.objects),
                    checkContinueBtnState: true,
                    propsUpdated: false
                }
            );
        }
    }

    setTabActive(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
        if(this.state.activeScreen.screen_id !== screen.screen_id){
            this.setState({activeScreen: screen, renderedScreen: {}, focusedTab: screen});
        }
        let focusEl = document.getElementById(`${this.state.screen.screen_id}_feed`);
        //focusEl.focus();
        //this.setBackButtonDisplayState(object);
        //this.setContinueButtonDisplayState(object);
    }

    setRenderedScreen() {
        let screenType = Object.assign({}, getScreenComponentByType(this.state.activeScreen.screen_type),
            {
                data: this.state.activeScreen
            }
        );

        this.setState({renderedScreen: Object.assign({}, screenType)});
    }

    onSubScreenComplete(screen) {
        //console.log(screen);
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};
        let nextScreenIndex = -1;

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            nextScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", nextScreen.screen_id);
        }

        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" || nextScreenIndex === -1 ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true
                }
            );

            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, object.object_id);
        }

        this.checkScreenComplete();
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setTabActive(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    navigateToNextScreen() {
        let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
            this.context.router.push('menu');
        } else {
            this.props.actions.setNextLessonLocation(this.getScreenId());
        }
    }

    getNextlessonLocation(){
        let next_lesson_location = 0;
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            next_lesson_location = this.state.screen.next_screen_id;
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {

                next_lesson_location = navigationHelper.getNextLessonLocation(this.getScreenId());
            }
        }

        return next_lesson_location;
    }

    handleNextButton(){
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if(next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    checkScreenComplete() {
        if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE,
                    setNextButton: true,
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen() {
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE,
                setNextButton: true,
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };
        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    setTabLayoutStyle() {
        if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL) {
            return "tabbed-content-vertical floating";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS) {
            return "tabbed-content";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) {
            return "tabbed-content-vertical";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_PROCESS) {
            return "tabbed-content-process-horizontal";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_PROCESS) {
            return "tabbed-content-process-vertical";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_TILE) {
            return "tabbed-content-tile-horizontal";
        } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_TILE) {
            return "tabbed-content-tile-vertical";
        } else {
            return "tabbed-content floating";
        }
    }

    getTabComponent(){
        if (appHelper.isDefined(this.state.screen.tab_type) && (this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_PROCESS || this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_PROCESS)){
            return ProcessBtn;
        }else{
            return Tab;
        }

    }

    getPrevTab() {
        let tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
        let nextTab = this.state.screen.sub_screens[tabIndex - 1];
        if (tabIndex <= 0) {
            nextTab = this.state.screen.sub_screens[this.state.screen.sub_screens.length - 1];
        }
        //console.log(`getPrevTab`,nextTab);
        this.setState({focusedTab: Object.assign({}, nextTab)});
    }

    getNextTab() {
        let tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
        let nextTab = this.state.screen.sub_screens[tabIndex + 1];
        if (tabIndex === (this.state.screen.sub_screens.length - 1)) {
            nextTab = this.state.screen.sub_screens[0];
        }
        //console.log(`getNextTab`,nextTab);

        this.setState({focusedTab: Object.assign({}, nextTab)});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            if (appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", this.state.focusedTab.screen_id) > -1) {
                event.preventDefault();
                this.setTabActive(this.state.focusedTab);
            }
        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevTab();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextTab();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevTab();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextTab();
        }
    }


    setTabCallbacks() {
        this.setState({
            tabCallbacks: Object.assign({}, this.state.tabCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
         });
    }

    includeIcons(){
        return appHelper.isDefined(this.state.screen.include_icon) && this.state.screen.include_icon;
    }

    render() {
        let renderedScreen = this.state.renderedScreen;
        let TabComponent = this.getTabComponent();
        return (
            <div className="customer-scenario">
                <div className="background-container">
                    <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                </div>
                <div className="screen-container">
                    <div className={this.setTabLayoutStyle()}>
                        <div className={`tab-list even-widths ${this.includeIcons() ? "icon-list" : ""}`} role="tablist">
                            <div className="tab-item-wrapper">
                            {this.state.screen.sub_screens.length > 0
                                ?
                                this.state.screen.sub_screens.map(sub_screen =>
                                typeof this.state.activeScreen.screen_id !== "undefined"
                                    ? <TabComponent key={`${sub_screen.screen_id}_tab`}
                                           parentScreen={this.state.screen}
                                           screen={sub_screen}
                                           activeScreenId={this.state.activeScreen.screen_id}
                                           enabledScreens={this.state.enabledScreens}
                                           completeScreens={this.state.completeScreens}
                                           onClickFunc={this.setTabActive}
                                           ref={`tab_btn_${sub_screen.screen_id}`}
                                           focusedTab={this.state.focusedTab}
                                           tabCallbacks={this.state.tabCallbacks}
                                    />
                                    :
                                    null

                                )
                            :
                                <div className={`tab-item`}/>
                            }
                            </div>
                        </div>
                        <div className={`tabbed-body-content ${this.includeIcons() ? "icon-body" : ""}`} ref={`${this.state.screen.screen_id}_feed`}
                             id={`${this.state.screen.screen_id}_feed`} role="tabpanel"
                             aria-labelledby={`tab_${this.state.activeScreen.screen_id}`}>
                            {typeof renderedScreen.data !== "undefined" && this.state.screenIsReady
                                ?
                                <renderedScreen.component screen={renderedScreen.data} parentScreen={this.state.screen}
                                                          biteCallbacks={this.state.callbacks}/>
                                : null
                            }

                            {
                                !this.state.screenIsReady
                                    ?
                                    <div>

                                        {
                                            this.state.producerNotes.show_notes
                                                ?
                                                <ProducerNotes notes={this.state.producerNotes.notes}
                                                               screen_id={this.state.screen.screen_id}/>
                                                :
                                                null
                                        }
                                        <NotReadyYet screen_id={this.state.screen.screen_id} onContinue={this.navigateToNextScreen}/>

                                    </div>
                                    :
                                    null
                            }
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}

/*
* <div className="tabbed-body-footer">
                            <div className="text-center">
                                footer

                            </div>
                        </div>
* */

TabbedScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

TabbedScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        titles: state.titles,
        userData: state.userData,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TabbedScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/tabbedScreen/TabbedScreen.js
 **/